import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import moment from 'moment';
import "./DashBoard.scss";

@inject('commonStore','companyStore')
@observer
class DashBoard extends Component {

  UNSAFE_componentWillMount() {
    this.props.companyStore.disDashboardInfo();
    this.props.companyStore.disCompanyList("M", 'Y');
  }

  render() {
    const { dashboardInfo } = this.props.companyStore;
    return (
      dashboardInfo !== null &&
      <Fragment>
        <div className="main_db_t" onClick={()=>this.props.history.push('/transManage')}>
          <div className="main_db_date">
            {moment().format('YYYY 년 MM 월 DD 일')}
          </div>
          <div className="main_db_total">
            <div>
              <div>어제 주문</div>
              <span>
                {(dashboardInfo.yesterOrderCnt !== undefined && dashboardInfo.yesterOrderCnt !== null)
                ? dashboardInfo.yesterOrderCnt : 0} 건
              </span>
              &nbsp;&nbsp;
              <span>
                {(dashboardInfo.yesterOrderPrice !== undefined && dashboardInfo.yesterOrderPrice !== null)
                ? dashboardInfo.yesterOrderPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0} 원
              </span>
            </div>
            <div>
              <div>현재 주문</div>
              <span>
                {(dashboardInfo.todayOrderCnt !== undefined && dashboardInfo.todayOrderCnt !== null)
                ? dashboardInfo.todayOrderCnt : 0} 건
              </span>
              &nbsp;&nbsp;
              <span>
                {(dashboardInfo.todayOrderPrice !== undefined && dashboardInfo.todayOrderPrice !== null)
                ? dashboardInfo.todayOrderPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0} 원
              </span>
            </div>
          </div>
        </div>

        <div className="main_db_order_status" onClick={()=>this.props.history.push('/transManage')}>
            <div>          
              승인대기
              <b>{(dashboardInfo.stat_standby !== undefined && dashboardInfo.stat_standby !== null)
                  ? dashboardInfo.stat_standby : 0} <span className="txt_hide">건</span></b>
            </div>
            <div>          
              승인완료
              <b>{(dashboardInfo.stat_completion !== undefined && dashboardInfo.stat_completion !== null)
                  ? dashboardInfo.stat_completion : 0} <span className="txt_hide">건</span></b>
            </div>
          <div>          
            배송준비
            <b>{(dashboardInfo.stat_ready !== undefined && dashboardInfo.stat_ready !== null)
                ? dashboardInfo.stat_ready : 0} <span className="txt_hide">건</span></b>
          </div>
          <div>          
            배송중
            <b>{(dashboardInfo.stat_shipping !== undefined && dashboardInfo.stat_shipping !== null)
                ? dashboardInfo.stat_shipping : 0} <span className="txt_hide">건</span></b>
          </div>
          <div>          
            구매확정
            <b>{(dashboardInfo.stat_end !== undefined && dashboardInfo.stat_end !== null)
                ? dashboardInfo.stat_end : 0} <span className="txt_hide">건</span></b>
          </div>
        </div>
        
        <div className="main_db_b_total" onClick={()=>this.props.history.push('/transManage')}>
          <table>
            <tbody>
              <tr>
                <th rowSpan="2">누적</th>
                <th>{moment().format('YYYY 년 MM 월 01일')} ~ 현재</th>
                <td>
                {(dashboardInfo.nextMonthEndCnt !== undefined && dashboardInfo.nextMonthEndCnt !== null)
                ? dashboardInfo.nextMonthEndCnt : 0} 건
                &nbsp;&nbsp;
                {(dashboardInfo.nextMonthEndPrice !== undefined && dashboardInfo.nextMonthEndPrice !== null)
                ? dashboardInfo.nextMonthEndPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0} 원
                </td>
              </tr>
              <tr>
                <th>{moment().subtract(1, 'month').format('YYYY 년 MM 월')}</th>
                <td>
                {(dashboardInfo.lastMonthEndCnt !== undefined && dashboardInfo.lastMonthEndCnt !== null)
                ? dashboardInfo.lastMonthEndCnt : 0} 건
                &nbsp;&nbsp;
                {(dashboardInfo.lastMonthEndPrice !== undefined && dashboardInfo.lastMonthEndPrice !== null)
                ? dashboardInfo.lastMonthEndPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0} 원
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }

}

export default withRouter(DashBoard);
